import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Logo } from '@assets/index';
import NavBrandStyles from './CustomNavBrand.module.scss';

export const CustomNavBrand: React.FC = () => {
  return (
    <Navbar.Brand href="/" className={NavBrandStyles.navbar_brand}>
      <Logo />
    </Navbar.Brand>
  );
};
